import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import "./EditDangerousItem.scss";
import { adminApi } from "../../../utils/api";
import { showSuccessToast, showErrorToast } from "../../../utils/toastNotifications";

export const EditDangerousItem = () => {
  const { id } = useParams(); // make sure your route provides :id
  const [formData, setFormData] = useState({ name: "", price: 0, id: id });
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token"));

  // Fetch existing item
  useEffect(() => {
    const fetchItem = async () => {
      try {
        const response = await adminApi.call(`/dangerousitem/${id}`, 'GET');

        if (!response.success) {
          showErrorToast(response.error || "Failed to fetch item");
          return;
        }

        setFormData(response.data);
      } catch (error) {
        showErrorToast("Error: " + error.message);
      }
    };

    fetchItem();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const submitUpdate = async () => {
    setLoading(true);

    try {
      const response = await adminApi.call('/dangerousitem/admin/Update', 'PUT', formData);

      if (!response.success) {
        showErrorToast(response.error || "Failed to update item");
        return;
      }

      showSuccessToast("Dangerous item updated successfully!");
    } catch (error) {
      showErrorToast("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-primary">Edit Dangerous Item</h2>
        <Link to="/dangerous-items" className="btn btn-secondary">
          <i className="fa fa-arrow-left"></i> Back to Index
        </Link>
      </div>

      <div className="mb-3">
        <label className="form-label">Name</label>
        <input
          type="text"
          className="form-control"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Price</label>
        <input
          type="number"
          className="form-control"
          name="price"
          value={formData.price}
          onChange={handleInputChange}
        />
      </div>

      <div className="text-center">
        <button
          className="btn btn-primary"
          onClick={submitUpdate}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update"}
        </button>
      </div>
    </div>
  );
};
